<template>
  <div>
    <GChart :settings="{ packages: ['corechart', 'controls'] }" style="display: none" type="LineChart" @ready="onChartReady" />
    <div id="chart-container" class="by-value">
      <div id="match-by-emotional-value-chart" class="value-emotional-needs row">
        <div id="match-by-emotional-value-title-and-chart">
          <div class="chart-title-container pl-3 pt-3" v-show="this.$parent.getDisplayView() && getDisplayView()">
            <h4 class="text-primary">Value Drivers</h4>
          </div>
          <div class="title-and-chart">
            <div class="title-and-chart-left">
              <chart-legend
                :include-number-of-responses="true"
                :class="getLegendClass('pb-1')"
                height="auto"
                :direction="'vertical'"
                :width="'auto'"
                location="Match By Value (Emotional)"
                :elements="$parent.legendElements"
                :container-id="'match-by-emotional-value-chart'"
                :show-number-of-responses="this.$parent.chartDisplayOptions.showNumberOfResponses"
                @redraw="showOrHideElementsForEmotionalNeeds"
              >
              </chart-legend>
            </div>
            <div class="buttons-and-chart">
                <chart-buttons
                :display="this.$parent.getDisplayView() && getDisplayView()"
                :include-remove-box="false"
                :tooltip-configuration="snapChartTooltipConfig"
                :snap-container-id="'match-by-emotional-value-title-and-chart'"
                :container-id="'match-by-emotional-value-chart'"
                :report-page-type-name="'Chart - Match Value Drivers'"
                :insight-modal-id="'value-drivers-chart'"
                :include-text-direction="false"
              >
              </chart-buttons>
              <div class="ml-5" style="position: relative">
                <div id="profile_match_by_value_emotional_chart" class="chart"></div>
                <div v-show="this.$parent.getDisplayView() && getDisplayView()" class="driver-header">
                  <div v-show="this.$parent.getDisplayView() && getDisplayView()" class="header-driver-name">Value Driver</div>
                  <div v-show="this.$parent.getDisplayView() && getDisplayView()" class="header-driver-weight">Weight</div>
                  <div v-show="this.$parent.getDisplayView() && getDisplayView()" class="header-emotional-intensity">Emotional Need</div>
                </div>
                <div v-show="this.$parent.getDisplayView() && getDisplayView()" class="chart-header driver-body">
                  <div class="d-flex justify-content-around" v-for="(driver, idxDriver) in drivers" v-bind:key="idxDriver">
                    <div class="driver-number">{{ idxDriver + 1 }}</div>
                    <div class="driver-name">{{ drivers[idxDriver].name }}</div>
                    <div class="driver-weight">{{ drivers[idxDriver].weight }}</div>
                    <div class="emotional-intensity">
                      <div class="driver d-flex justify-content-between">
                        <div>{{ drivers[idxDriver].emotionalNeedName1 }}</div>
                        <div>{{ drivers[idxDriver].emotionalNeedName2 }}</div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="this.$parent.getDisplayView() && getDisplayView()" :id="valueEmotionalTable.tableContainerId" class="chart-data row pt-5">
        <chart-data-table
          ref="emotionalDataTable"
          :chart-data="this.valueEmotionalTable.data"
          :data-container-id="valueEmotionalTable.tableContainerId"
          :container-id="'profile_match_by_value_emotional_chart'"
          :column-defs="this.chart.columnDefsEmotional"
          :table-class="'table display responsive row-border table-hover'"
          :table-width="'auto'"
          :table-title="this.valueEmotionalTable.title"
          :report-page-type-name="'Table - Match Value Drivers'"
          :insight-modal-id="'value-drivers-table'"
        ></chart-data-table>
      </div>
      <div id="match-by-functional-value-chart" class="value-functional-needs row">
        <div id="match-by-functional-value-title-and-chart" class="title-and-chart">
          <div class="title-and-chart-left">
            <div class="chart-title-container" v-show="this.$parent.getDisplayView() && getDisplayView()">
              <h4 class="text-primary">Value Components</h4>
            </div>
            <chart-legend
              :include-number-of-responses="true"
              :class="getLegendClass('pt-4 pb-1')"
              height="auto"
              :direction="'vertical'"
              :width="'auto'"
              :elements="$parent.legendElements"
              @redraw="showOrHideElementsForFunctionalNeeds"
              :container-id="'match-by-functional-value-chart'"
              :show-number-of-responses="this.$parent.chartDisplayOptions.showNumberOfResponses"
            >
            </chart-legend>
          </div>
          <div id="value_functional_needs_chart_width_header" class="buttons-and-chart">
            <chart-buttons
              :display="this.$parent.getDisplayView() && getDisplayView()"
              :tooltip-configuration="snapChartTooltipConfig"
              :container-id="'match-by-functional-value-chart'"
              :snap-container-id="'match-by-functional-value-title-and-chart'"
              :report-page-type-name="'Chart - Match Value Components'"
              :insight-modal-id="'value-components-chart'"
              :text-direction="this.$parent.chartDisplayOptions.functional.textDirection"
            >
            </chart-buttons>
            <div class="value-components-chart">
              <div v-show="this.$parent.getDisplayView() && getDisplayView()" class="chart-header">
                <driver-header
                  :driver-label-one="drivers[0].name"
                  :driver-label-two="drivers[1].name"
                  :driver-label-three="drivers[2].name"
                  :driver-label-four="drivers[3].name"
                  :driver-label-five="drivers[4].name"
                ></driver-header>
              </div>
              <div id="profile_match_by_value_functional_chart" class="chart"></div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="this.$parent.getDisplayView() && getDisplayView()" :id="valueFunctionalTable.tableContainerId" class="chart-data row pt-5">
        <chart-data-table
          ref="functionalDataTable"
          v-show="this.$parent.getDisplayView() && getDisplayView()"
          :chart-data="this.valueFunctionalTable.data"
          :display-direction="'vertical'"
          :data-container-id="valueFunctionalTable.tableContainerId"
          :container-id="'profile_match_by_value_functional_chart'"
          :column-defs="this.chart.columnDefsFunctional"
          :table-class="'table display responsive row-border table-hover'"
          :table-width="'auto'"
          :table-title="this.valueFunctionalTable.title"
          :report-page-type-name="'Table - Match Value Components'"
          :insight-modal-id="'value-components-table'"
        ></chart-data-table>
      </div>
</div>
    <insights
      ref="insightsFunctionalChart"
      :modal-name="'value-components-chart'"
      :report-page-type-name="'Chart - Match Value Components'"
      :entry-page-content="this.pageContentForReport"
      @saveReportPage="$parent.updateReportPages"
      @saveAllReportPages="saveAllReportPages"
      @saveClientChart="$parent.saveClientChart"
    />
    <insights
      ref="insightsFunctionalTable"
      :modal-name="'value-components-table'"
      :report-page-type-name="'Table - Match Value Components'"
      :entry-page-content="this.pageContentForReport"
      @saveReportPage="$parent.updateReportPages"
      @saveAllReportPages="saveAllReportPages"
      @saveClientChart="$parent.saveClientChart"
    />
    <insights
      ref="insightsEmotionalChart"
      :modal-name="'value-drivers-chart'"
      :report-page-type-name="'Chart - Match Value Drivers'"
      :entry-page-content="this.pageContentForReport"
      @saveReportPage="$parent.updateReportPages"
      @saveAllReportPages="saveAllReportPages"
      @saveClientChart="$parent.saveClientChart"
    />
    <insights
      ref="insightsEmotionalTable"
      :modal-name="'value-drivers-table'"
      :report-page-type-name="'Table - Match Value Drivers'"
      :entry-page-content="this.pageContentForReport"
      @saveReportPage="$parent.updateReportPages"
      @saveAllReportPages="saveAllReportPages"
      @saveClientChart="$parent.saveClientChart"
    />
  </div>
</template>
<script>
import $ from "jquery";
import ChartLegend from "../../../components/chart/ChartLegend.vue";
import ChartButtons from "../../../components/chart/ChartButtons.vue";
import DriverHeader from "../../../templates/DriverHeader.vue";
import NetPromoterScore from "../../../components/chart/NetPromoterScore.vue";

import ChartCompanyMixins from "../../../mixins/ChartCompanyMixins.vue";
import ChartService from "../../../services/chart.service";
import ErrorService from "../../../services/error.service";
import AdminService from "../../../services/admin.service";
import NeedsService from "../../../services/needs.service";
import TableService from "../../../services/table.service";
import ReportService from "../../../services/report.service";

export default {
  name: "MatchByValue",
  mixins: [ChartCompanyMixins],
  components: { ChartLegend, ChartButtons, DriverHeader  },
  data() {
    return {
      comparativeSize: 1,
      barBackgroundColorList: [],
      xBackgroundColorList: [],
      valueEmotionalChart: {},
      valueFunctionalChart: {},
      valueFunctionalTable: {
        id: "",
        data: {},
        tableContainerId: "value_functional_needs_data_container",
        title:
          "<h4 class='text-primary'>Value Components</h4><div class='chart-title functional'><div class='chart-sub-title'><span>Importance/Satisfaction Gap</span> vs. <span>Pricing Power</span></div></div>"
      },
      valueEmotionalTable: {
        id: "",
        data: {},
        tableContainerId: "value_emotional_needs_data_container",
        title:
          "<h4 class='text-primary'>Value Drivers</h4><div class='chart-title emotional'><div class='chart-sub-title'><span>Ideal/Company Gap</span> vs. <span>Pricing Power</span></div></div>"
      },
      drivers: [
        {
          name: "",
          weight: "",
          emotionalNeedName1: "",
          emotionalNeedName2: ""
        },
        {
          name: "",
          weight: "",
          emotionalNeedName1: "",
          emotionalNeedName2: ""
        },
        {
          name: "",
          weight: "",
          emotionalNeedName1: "",
          emotionalNeedName2: ""
        },
        {
          name: "",
          weight: "",
          emotionalNeedName1: "",
          emotionalNeedName2: ""
        },
        {
          name: "",
          weight: "",
          emotionalNeedName1: "",
          emotionalNeedName2: ""
        }
      ],
      itemsToRemoveFunctionalNeed: {
        firstColumns: 2
      },
      itemsToRemoveEmotionalNeed: {
        firstColumns: 1
      }
    };
  },
  props: {
    chartData: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  computed: {},
  mounted() {
    let vm = this;
    $(window).smartresize(function() {
      if (vm.$parent.isMatchByValue) {
        vm.smartRedrawChart($("#profile_match_by_value_functional_chart"));
        vm.smartRedrawChart($("#profile_match_by_value_emotional_chart"));
      }
    });
  },
  created() {},
  methods: {
    displayInsights(insightModalId, reportPageTypeName) {
      if (reportPageTypeName == "Chart - Match Value Components") {
        this.$refs.insightsFunctionalChart.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.$parent.reportPagesList);
        this.$refs.insightsFunctionalChart.initializeInsights(this.$parent.clientChart);
        this.$modal.show(insightModalId);
      } else if (reportPageTypeName == "Table - Match Value Components") {
        this.$refs.insightsFunctionalTable.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.$parent.reportPagesList);
        this.$refs.insightsFunctionalTable.initializeInsights(this.$parent.clientChart);
        this.$modal.show(insightModalId);
      } else if (reportPageTypeName == "Chart - Match Value Drivers") {
        this.$refs.insightsEmotionalChart.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.$parent.reportPagesList);
        this.$refs.insightsEmotionalChart.initializeInsights(this.$parent.clientChart);
        this.$modal.show(insightModalId);
      } else if (reportPageTypeName == "Table - Match Value Drivers") {
        this.$refs.insightsEmotionalTable.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.$parent.reportPagesList);
        this.$refs.insightsEmotionalTable.initializeInsights(this.$parent.clientChart);
        this.$modal.show(insightModalId);
      }
    },
    onChartReady(chart, google) {
      this.chartsLib = google;
      this.valueEmotionalChart = new google.visualization.ChartWrapper({
        chartType: "ComboChart",
        containerId: "profile_match_by_value_emotional_chart"
      });
      this.valueFunctionalChart = new google.visualization.ChartWrapper({
        chartType: "LineChart",
        containerId: "profile_match_by_value_functional_chart"
      });
    },
    async processChartData() {
      try {
        this.$parent.resetChartDisplayOptions();
        this.chart = ChartService.getChartAttributes("Match By Value");
        for (let i = 0; i < this.chartData.length; i++) {
          let needsData = JSON.parse(JSON.stringify(this.chartData[i]));
          let otherData = needsData["otherData"];
          let needsList = otherData["needsList"];
          let driverList = otherData["driverList"];
          let companyColorList = otherData["companyColorList"];
          let comparativeSize = otherData["comparativeSize"];
          this.barBackgroundColorList = otherData["barBackgroundColorList"];
          this.xBackgroundColorList = otherData["xBackgroundColorList"];
          this.comparativeSize = comparativeSize;

          let breakPointList = otherData["breakPointList"];
          TableService.setCompanyColorList(companyColorList);
          ChartService.setVerticalLineBreakPoints(breakPointList);
          let dynamicChartOptions = needsData["options"];
          let containerId = needsData["containerId"];
          let chartOptions = ChartService.getChartOptions(containerId);
          $.extend(chartOptions, dynamicChartOptions);
          this.table.id = containerId;

          if (containerId === "profile_match_by_value_functional_chart") {
            this.$parent.legendElements = otherData["legend"];
            let breakPointList = otherData["breakPointList"];
            ChartService.setVerticalLineBreakPoints(breakPointList);
            let functionalNeedChart = $("#profile_match_by_value_functional_chart");

            NeedsService.setFunctionalNeedsList(needsList);

            for (let index = 0; index < driverList.length; index++) {
              this.drivers[index].name = driverList[index].name;
              let weight = driverList[index].weight;
              if (weight != null && !isNaN(weight)) {
                let finalWeight = weight * 100;
                this.drivers[index].weight = Number(finalWeight).toFixed(1) + "%";
              } else {
                this.drivers[index].weight = "--";
              }
            }
            this.valueFunctionalTable.id = containerId;
            this.valueFunctionalTable.data = JSON.parse(JSON.stringify(needsData));
            this.$parent.setChartResults(needsData.companyList);
            this.$parent.$data.criteriaResultsList = AdminService.removeByName(needsData.criteriaList, "Competitor");
            this.$parent.functionalChartOptions = JSON.parse(JSON.stringify(chartOptions));
            this.$parent.functionalChartOptions = ChartService.setHAxisFormat(this.$parent.chartDisplayOptions.functional.textDirection, this.$parent.functionalChartOptions);
            await ChartService.paintChart(
              this.$data.valueFunctionalChart,
              containerId,
              this.$parent.functionalChartOptions,
              needsData,
              this,
              comparativeSize,
              this.itemsToRemoveFunctionalNeed.firstColumns
            );
            this.resetLegendElements();
          } else if (containerId === "profile_match_by_value_emotional_chart") {
            this.$parent.legendElements = otherData["legend"];
            let labelIndex = 1;
            NeedsService.setEmotionalNeedsList(needsList);
            this.valueEmotionalTable.id = containerId;
            let copyOfChartData = JSON.parse(JSON.stringify(needsData));

            for (let indexRows = 0; indexRows < needsData.rows.length; indexRows++) {
              let copyOfChartDataRow = copyOfChartData.rows[indexRows].c;
              let originalName = copyOfChartDataRow[labelIndex].v;
              let copyValue = copyOfChartDataRow[labelIndex].v.split(",");
              if (typeof copyValue != "undefined") {
                copyOfChartDataRow[labelIndex].v = copyValue[0] + " (vs. " + copyValue[1] + ")";
                NeedsService.replaceNeedName(originalName, copyOfChartDataRow[labelIndex].v, "emotional");
                this.drivers[indexRows].emotionalNeedName1 = copyValue[1];
                this.drivers[indexRows].emotionalNeedName2 = copyValue[0];
              }
            }
            this.valueEmotionalTable.data = copyOfChartData;
            this.$parent.emotionalChartOptions = JSON.parse(JSON.stringify(chartOptions));
            await ChartService.paintChart(this.$data.valueEmotionalChart, containerId, chartOptions, needsData, this, 0, this.itemsToRemoveEmotionalNeed.firstColumns);
            this.resetLegendElements();
          }
        }
        this.$root.$emit("check-number-of-responses");     
        this.setDisplayView(true);
        this.$parent.setDisplayView(true);
      } catch (err) {
        ErrorService.processException("CompetitiveTrends.displayChartCallback", err, "chart", this);
      }
    },
    setShowNumberOfResponses(value){
      this.$parent.chartDisplayOptions.showNumberOfResponses = value;
    },    
    async setXAxisTextDirection(containerId, direction){
      if (typeof this.$parent.$refs.chartCriteria != "undefined"){
          this.$parent.$refs.chartCriteria.setTextDirection(direction);
      }      
      this.$parent.functionalChartOptions = ChartService.setHAxisFormat(direction, this.$parent.functionalChartOptions);
      this.$parent.chartDisplayOptions.functional.textDirection = direction;
      this.prePaintChart(true, "profile_match_by_value_functional_chart");
    },

    async showOrHideElementsForFunctionalNeeds(element) {
      this.$parent.chartDisplayOptions.redrawAdditionalWidgets = false;
      let needsData = JSON.parse(JSON.stringify(this.chartData[0]));
      let elementId = element.elementId;
      if (element.visible == true) {
        if (elementId.includes("x-")) {
          this.$parent.setPaintX(element, "functional");
        }
        if (element.symbolClass.includes("bar-")) {
          this.$parent.setPaintBar(element, "functional");
        }
      }
      let chartContainer = $("#" + this.valueFunctionalTable.id);
      this.$parent.showOrHideElementsForFunctionalNeeds(element, chartContainer);
      await ChartService.paintChart(
        this.$data.valueFunctionalChart,
        this.valueFunctionalTable.id,
        this.$parent.functionalChartOptions,
        needsData,
        this,
        this.comparativeSize,
        this.itemsToRemoveFunctionalNeed.firstColumns
      );
    },
    async showOrHideElementsForEmotionalNeeds(element) {
      this.$parent.chartDisplayOptions.redrawAdditionalWidgets = false;
      let needsData = JSON.parse(JSON.stringify(this.chartData[1]));
      let elementId = element.elementId;
      if (element.visible == true) {
        if (elementId.includes("x-")) {
          this.$parent.setPaintX(element, "emotional");
        }
        if (elementId.includes("bar-")) {
          this.$parent.setPaintBar(element, "emotional");
        }
      }
      let chartContainer = $("#" + this.valueEmotionalTable.id);
      this.$parent.showOrHideElementsForEmotionalNeeds(element, chartContainer);
      await ChartService.paintChart(
        this.$data.valueEmotionalChart,
        this.valueEmotionalTable.id,
        this.$parent.emotionalChartOptions,
        needsData,
        this,
        0,
        this.itemsToRemoveEmotionalNeed.firstColumns
      );
    },
    async smartRedrawChart(generatedChart) {
      generatedChart.find(".blueX").remove();
      generatedChart.find(".bar").remove();
      generatedChart.find(".vertical-line").remove();
      generatedChart.find(".blue-vertical-line").remove();
      this.prePaintChart(true, "profile_match_by_value_functional_chart");
      this.prePaintChart(true, "profile_match_by_value_emotional_chart");
    },
    async prePaintChart(redrawWidgets, containerId) {
      this.redrawAdditionalWidgets = redrawWidgets;
      if (containerId === "profile_match_by_value_functional_chart") {
        let needsData = JSON.parse(JSON.stringify(this.chartData[0]));
        await ChartService.paintChart(
          this.$data.valueFunctionalChart,
          this.valueFunctionalTable.id,
          this.$parent.functionalChartOptions,
          needsData,
          this,
          this.comparativeSize,
          this.itemsToRemoveFunctionalNeed.firstColumns
        );
      } else {
        let needsData = JSON.parse(JSON.stringify(this.chartData[1]));
        await ChartService.paintChart(
          this.$data.valueEmotionalChart,
          this.valueEmotionalTable.id,
          this.$parent.emotionalChartOptions,
          needsData,
          this,
          0,
          this.itemsToRemoveEmotionalNeed.firstColumns
        );
      }
    },

    postPaintChart(primary_chart, containerId, options, dataTable) {
      if (containerId == "profile_match_by_value_functional_chart") {
        this.addAdditionalChartWidgetsByFunctionalNeed(primary_chart, containerId, options, dataTable);
      } else if (containerId == "profile_match_by_value_emotional_chart"){
        this.addAdditionalChartWidgetsByEmotionalNeed(primary_chart, containerId, options, dataTable);
      }
      this.saveReportPage(containerId);
    },
    async saveReportPage(containerId) {
      let reportPageChartName = containerId === "profile_match_by_value_functional_chart" ? "Chart - Match Value Components" : "Chart - Match Value Drivers";
      let reportPageTableName = containerId === "profile_match_by_value_functional_chart" ? "Table - Match Value Components" : "Table - Match Value Drivers";
      let tableContainerId = containerId === "profile_match_by_value_functional_chart" ? this.valueFunctionalTable.tableContainerId : this.valueEmotionalTable.tableContainerId;
      let imageClass = containerId === "profile_match_by_value_functional_chart" ? 'pdf-content-image-height' : 'pdf-content-image-width';

      let reportPageChartContent = "";
      let reportPageChart;
      if (this.$parent.clientChart.clientChartId != 0  && this.isGenerateReportRunning() ) {
        if (containerId === "profile_match_by_value_functional_chart") {
          reportPageChart = $("#match-by-functional-value-title-and-chart");
        } else {
          reportPageChart = $("#match-by-emotional-value-title-and-chart");
        }
        reportPageChart.find(".chart-header").css("display", "block");
        reportPageChart.find(".driver-header").css("display", "flex");
        reportPageChart.find(".header-driver-name").css("display", "block");
        reportPageChart.find(".header-driver-weight").css("display", "block");
        reportPageChart.find(".header-emotional-intensity").css("display", "block");
        let reportPageChartObject = reportPageChart[ 0 ];
        let imageData = await this.createChartImageMap(reportPageChartObject, false, false, 10, imageClass); 
        await ReportService.saveReportPage(imageData.content, reportPageChartName, this.$parent.clientChart, this.saveReportPageCallback, this);
        await ReportService.saveReportPageFile(imageData.url, "png", reportPageChartName, this.$parent.clientChart, this.saveReportPageCallback, this);
/*
        let imageReportPageTableContent = await this.createTableImage(this, tableContainerId, false, 750, 10); 
        await ReportService.saveReportPage(imageReportPageTableContent, reportPageTableName, this.$parent.clientChart, this.saveReportPageCallback, this);
        await ReportService.saveReportPageFile(this.tableImageUrl, "png", reportPageTableName, this.$parent.clientChart, this.saveReportPageFileCallback, this);
*/       
        if (containerId === "profile_match_by_value_functional_chart") {
          await ReportService.saveReportTableFile(this.$refs.functionalDataTable.getTableData(), reportPageTableName, this.$parent.clientChart, this.saveReportTableFileCallback, this);
        } else {
          await ReportService.saveReportTableFile(this.$refs.emotionalDataTable.getTableData(), reportPageTableName, this.$parent.clientChart, this.saveReportTableFileCallback, this);
        }

        await ReportService.saveReportPage(this.getReportTableContent(containerId), reportPageTableName, this.$parent.clientChart, this.saveReportPageCallback, this);
      }
    },
    saveAllReportPages() {
      this.saveReportPage("profile_match_by_value_functional_chart");
      this.saveReportPage("profile_match_by_value_emotional_chart");
    },
    async addAdditionalChartWidgetsByFunctionalNeed(primary_chart, containerId, options, dataTable) {
      let yAxisIndex = 1;

      let chartContainer = $("#" + containerId);
      let chartInterface = primary_chart.getChartLayoutInterface();
      let parentContainer = chartContainer.parent();
      var chartHeader = parentContainer.find(".chart-header");
      let chartBase = {
        width: 0,
        left: 0,
        top: 6,
        height: chartInterface.getChartAreaBoundingBox().height
      };
      let verticalLine = {
        top: chartBase.top + 1,
        height: chartBase.height - 5,
        left: chartBase.left + 1
      };
      let blueX = {
        top: chartBase.top - 13,
        left: chartBase.left - 8
      };
      let baseGreenBar = {
        top: chartBase.top - 8,
        left: chartBase.left - 10
      };
      ChartService.buildCompanyColor(this.xBackgroundColorList, chartContainer);

      let gap = (chartInterface.getXLocation(1) - chartInterface.getXLocation(0)) / 2;
      let moatIndex = ChartService.getVerticalLineBreakPoints();
      let previousXPos = 51;
      let driverHeaderWidth = 0;
      for (var rowIndex = 0; rowIndex < dataTable.getNumberOfRows(); rowIndex++) {
        let greenBarColumnIndex = 1;
        let blueXColumnIndex = 2;
        for (var comparativeIndex = 0; comparativeIndex < this.comparativeSize; comparativeIndex++) {
          let value = dataTable.getValue(rowIndex, greenBarColumnIndex);
          if (!isNaN(value) && value > 0) {
            let greenBarLeft = chartInterface.getXLocation(rowIndex) + baseGreenBar.left;
            let greenBarTop = chartInterface.getYLocation(value, yAxisIndex) + baseGreenBar.top;
            let barClassName = "bar";
            if (comparativeIndex >= 0) {
              barClassName += " bar-" + comparativeIndex;
            }
            if (
              (barClassName.includes("bar-0") && this.$parent.chartDisplayOptions.functional.paintBar == false) ||
              (barClassName.includes("bar-1") && this.$parent.chartDisplayOptions.functional.paintBar1 == false) ||
              (barClassName.includes("bar-2") && this.$parent.chartDisplayOptions.functional.paintBar2 == false) ||
              (barClassName.includes("bar-3") && this.$parent.chartDisplayOptions.functional.paintBar3 == false) ||
              (barClassName.includes("bar-4") && this.$parent.chartDisplayOptions.functional.paintBar4 == false) ||
              (barClassName.includes("bar-5") && this.$parent.chartDisplayOptions.functional.paintBar5 == false)
            ) {
              let barHOLDER = 1;
            } else {
              let currentBarBackgroundColor = ChartService.getBarColor(comparativeIndex, this.barBackgroundColorList);
              chartContainer.append(ChartService.paintBar(greenBarTop, greenBarLeft, barClassName, currentBarBackgroundColor));
            }
          }
          let blueXClassName = "blueX heavy";
          if (comparativeIndex >= 0) {
            blueXClassName += " x-" + comparativeIndex;
          }
          if (
            (blueXClassName.includes("x-0") && this.$parent.chartDisplayOptions.functional.paintX == false) ||
            (blueXClassName.includes("x-1") && this.$parent.chartDisplayOptions.functional.paintX1 == false) ||
            (blueXClassName.includes("x-2") && this.$parent.chartDisplayOptions.functional.paintX2 == false) ||
            (blueXClassName.includes("x-3") && this.$parent.chartDisplayOptions.functional.paintX3 == false) ||
            (blueXClassName.includes("x-4") && this.$parent.chartDisplayOptions.functional.paintX4 == false) ||
            (blueXClassName.includes("x-5") && this.$parent.chartDisplayOptions.functional.paintX5 == false)
          ) {
            let blueHOLDER = 1;
          } else {
            ChartService.paintDataPoints(options, chartInterface, dataTable, chartContainer, blueXColumnIndex, yAxisIndex, blueX.left, blueX.top, blueXClassName);
          }
          greenBarColumnIndex = greenBarColumnIndex + 2;
          blueXColumnIndex = blueXColumnIndex + 2;
        }
        if (typeof moatIndex != "undefined" && moatIndex.includes(rowIndex)) {
          let xPos = chartInterface.getXLocation(rowIndex);
          xPos += gap;
          let className = "blue-vertical-line";
          chartContainer.append(ChartService.paintVerticalLine(verticalLine.top, xPos, verticalLine.height, className));
          let driverHeaderNumber = moatIndex.indexOf(rowIndex) + 1;
          driverHeaderWidth = xPos - previousXPos;
          previousXPos = xPos;
          var driverHeader = parentContainer.find(".driver-header-" + driverHeaderNumber);
          driverHeader.css("width", driverHeaderWidth + "px");
        }
      }
      if (this.isMobile) {
        chartHeader.css("visibility", "hidden");
      } else {
        chartHeader.css("visibility", "visible");
        chartHeader.css("position", "relative");
        chartHeader.css("width", chartInterface.getChartAreaBoundingBox().width + 2 + "px");
        chartHeader.css("left", chartInterface.getChartAreaBoundingBox().left - 1 + "px"); //
      }
      if (this.$parent.chartDisplayOptions.redrawAdditionalWidgets == true) {
        let driverHeader5 = parentContainer.find(".driver-header-5");
        driverHeaderWidth = parentContainer.width() - chartInterface.getChartAreaBoundingBox().width + gap;
        driverHeader5.css("width", driverHeaderWidth + "px");
        this.drawCPLine(parentContainer.parent(), chartInterface, 40);
      }
      ChartService.positionChartButtons(chartInterface, parentContainer.parent());
      $("#match-by-functional-value-chart").addClass("chart-wrapper");
    },
    async addAdditionalChartWidgetsByEmotionalNeed(primary_chart, containerId, options, dataTable) {
      let chartContainer = $("#" + containerId);
      let chartInterface = primary_chart.getChartLayoutInterface();
      let parentContainer = chartContainer.parent();
      let chartLegend = parentContainer.find(".chart-legend");
      let chartWidth = parentContainer.width();
      this.chartWidthEmotionalNeed = chartWidth + "px";
      chartLegend.css("position", "relative");
      let chartBase = {
        width: 0,
        top: 6,
        left: 0
      };
      let blueX = {
        top: chartBase.top - 12,
        left: chartBase.left - 8
      };
      let baseGreenBar = {
        top: chartBase.top - 15,
        left: chartBase.left - 2
      };
      ChartService.buildCompanyColor(this.xBackgroundColorList, chartContainer);

      for (var rowIndex = dataTable.getNumberOfRows() - 1; rowIndex >= 0; rowIndex--) {
        let yLocation = rowIndex;
        let greenBarColumnIndex = 2;
        let blueXColumnIndex = 3;
        let classNameIndex = 0;
        for (var comparativeIndex = this.comparativeSize - 1; comparativeIndex >= 0; comparativeIndex--) {
          let value = dataTable.getValue(rowIndex, greenBarColumnIndex);

          let greenBarLeft = chartInterface.getXLocation(value, 1) + baseGreenBar.left;
          let greenBarTop = chartInterface.getYLocation(yLocation) + baseGreenBar.top;
          let barClassName = "bar-vertical";
          let blueXClassName = "blueX heavy";
          if (comparativeIndex == this.comparativeSize - 1) {
            barClassName += " bar-0";
            blueXClassName += " x-0";
          } else {
            barClassName += " bar-" + classNameIndex;
            blueXClassName += " x-" + classNameIndex;
          }
          classNameIndex = classNameIndex + 1;
          if (
            (barClassName.includes("bar-0") && this.$parent.chartDisplayOptions.emotional.paintBar == false) ||
            (barClassName.includes("bar-1") && this.$parent.chartDisplayOptions.emotional.paintBar1 == false) ||
            (barClassName.includes("bar-2") && this.$parent.chartDisplayOptions.emotional.paintBar2 == false) ||
            (barClassName.includes("bar-3") && this.$parent.chartDisplayOptions.emotional.paintBar3 == false) ||
            (barClassName.includes("bar-4") && this.$parent.chartDisplayOptions.emotional.paintBar4 == false)
          ) {
            let barHOLDER = 1;
          } else {
            if (!isNaN(value)) {
              let currentBarBackgroundColor = ChartService.getBarColor(classNameIndex-1, this.barBackgroundColorList);
              chartContainer.append(ChartService.paintBar(greenBarTop, greenBarLeft, barClassName, currentBarBackgroundColor));
            }
          }

          var valueBlue = dataTable.getValue(rowIndex, blueXColumnIndex);
          if (valueBlue >= options.hAxis.viewWindow.min && valueBlue <= options.hAxis.viewWindow.max) {
            let leftPositionBlue = chartInterface.getXLocation(valueBlue, 1) + blueX.left;
            let topPositionsBlue = chartInterface.getYLocation(yLocation) + blueX.top;
            if (
              (blueXClassName.includes("x-0") && this.$parent.chartDisplayOptions.emotional.paintX == false) ||
              (blueXClassName.includes("x-1") && this.$parent.chartDisplayOptions.emotional.paintX1 == false) ||
              (blueXClassName.includes("x-2") && this.$parent.chartDisplayOptions.emotional.paintX2 == false) ||
              (blueXClassName.includes("x-3") && this.$parent.chartDisplayOptions.emotional.paintX3 == false) ||
              (blueXClassName.includes("x-4") && this.$parent.chartDisplayOptions.emotional.paintX4 == false)
            ) {
              let blueHOLDER = 1;
            } else {
              chartContainer.append(ChartService.paintBlueX(topPositionsBlue, leftPositionBlue, blueXClassName));
              chartContainer.append(ChartService.paintPDFVerionOfBlueX(topPositionsBlue - 3, leftPositionBlue, blueXClassName));
            }
          }
          blueXColumnIndex = blueXColumnIndex + 2;
          greenBarColumnIndex = greenBarColumnIndex + 2;
        }
      }
      if (this.$parent.chartDisplayOptions.redrawAdditionalWidgets == true) {
        let driverHeaderWidth = chartInterface.getChartAreaBoundingBox().width + chartInterface.getChartAreaBoundingBox().left + 1;
        var driverHeader = parentContainer.find(".driver-header");
        driverHeader.css("top", "2px");
        driverHeader.css("position", "absolute");
        driverHeader.css("width", driverHeaderWidth + "px");
        ChartService.positionChartButtons(chartInterface, parentContainer.parent(),38);
        let driverBodyTop = chartInterface.getChartAreaBoundingBox().top;
        var driverBody = parentContainer.find(".driver-body");
        driverBody.css("top", driverBodyTop + "px");
        driverBody.css("position", "absolute");
        driverBody.css("width", driverHeaderWidth + "px");

        let driverWeightWidth = parentContainer.find(".driver-weight").width();
        let emotionalIntensity = parentContainer.find(".emotional-intensity");
        let headerEmotionalIntensity = parentContainer.find(".header-emotional-intensity");
        let emotionalIntensityWidth = chartInterface.getChartAreaBoundingBox().width;
        let valueDriveWidth = driverHeaderWidth - emotionalIntensityWidth - driverWeightWidth - 5;

        var driverNameHeader = parentContainer.find(".driver-name");
        driverNameHeader.css("width", valueDriveWidth + "px");

        let headerDriverName = parentContainer.find(".header-driver-name");
        let headerDriverNameWidth = valueDriveWidth + 5;
        headerDriverName.css("width", headerDriverNameWidth + "px");

        let headerEmotionalIntensityWidth = chartInterface.getChartAreaBoundingBox().width;
        emotionalIntensity.css("width", emotionalIntensityWidth + "px");
        headerEmotionalIntensity.css("width", headerEmotionalIntensityWidth + "px");

        let driver = parentContainer.find(".driver");
        driver.css("height", chartInterface.getBoundingBox("bar#0#1").height + "px");

        parentContainer.css("background-color", "white");
        $("#chart-container").css("background-color", "white");
        $("#match-by-emotional-value-chart").addClass("chart-wrapper");
      }
    },
    getLegendClass: function(legendClass) {
      if (this.$parent.getDisplayView() && this.getDisplayView()) {
        legendClass += " visible";
      } else {
        legendClass += " invisible";
      }
      return legendClass;
    }
  },
  watch: {
    chartData: function() {
      /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      try{this.valueFunctionalChart.getChart().clearChart();} catch(e){}
      /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      try{this.valueEmotionalChart.getChart().clearChart();} catch(e){}      
      if (this.$parent.$refs.chartCriteria.$data.displayType == "value") {
        this.processChartData();
      } else {
        this.setDisplayView(false);
      }
    }
  }
};
</script>
